module.exports = __webpack_public_path__ + "img/watermark.ca5c5638.svg";